var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticClass:"partLoading"},[_c('mt-spinner',{attrs:{"color":"#01B5CE","type":"fading-circle"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }